import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net-bs4"; // or "datatables.net" for custom styling
import { Link } from "react-router-dom";
import ConfirmModal from "../../Components/ConfirmModal/ConfirmModal";
import FiltersBox from "../../Components/FiltersModal/FiltersBox";
import ContentHeader from "../../Components/ContentHeader/ContentHeader";
import Loading from "../../Components/Loading/Loading";
import Table from "../../Components/Table/Table";
import Search from "../../Components/Search/Search";
import CustomToast from "../../Components/CustomToast/CustomToast";
import { Formik } from "formik";
import FormModal from "../../Components/FormModal/FormModal";

function AnnouncementsUi({
  columns,
  data,
  tableQaury,
  onPageChange,
  totalRecords,
  loading,
  deleteAuditFn,
  decodedToken,
  toast,
  handleSubmit,
  validationSchemaSe,
  showForm,
  setShowForm,
  handleCloseModal,
}) {
  const totalPages = Math.ceil(totalRecords / tableQaury?.rowsPerPage);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}

            <ContentHeader
              title={"Announcement"}
              buttonName={""}
              buttonBoolean={false}
              pageName={""}
              linkPath={""}
            />

            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                {/* <div className="card">
                    
                  <div>
                    <h4 className="modal-title">Add Announcement</h4>
                    <Formik
                      initialValues={{
                        title: "",
                        description: "",
                      }}
                      validationSchema={validationSchemaSe}
                    
                      onSubmit={async (values, { resetForm }) => {
                        try {
                          const response = await handleSubmit(values);
                          if (response?.data?.success) {
                            resetForm(); // Reset the form after successful submission
                          }
                        } catch (error) {
                          console.error(
                            "Error submitting announcement:",
                            error
                          );
                        }
                      }}
                    >
                      {(formik) => (
                        <form id="quickForm" onSubmit={formik?.handleSubmit}>
                          <div className="card-body">
                            {toast && (
                              <CustomToast
                                text={toast?.message}
                                type={toast?.type}
                              />
                            )}
                            <div className="row">
                              <div className="col-6">
                                <div className="form-group">
                                  <label htmlFor="title">Title</label>
                                  <input
                                    type="text"
                                    name="title"
                                    className={`form-control ${
                                      formik.errors.title &&
                                      formik.touched.title
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    id="title"
                                    placeholder="Enter Title"
                                    {...formik.getFieldProps("title")}
                                  />
                                  {formik.errors.title &&
                                    formik.touched.title && (
                                      <span className="invalid-feedback">
                                        {formik.errors.title}
                                      </span>
                                    )}
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="form-group">
                                  <label htmlFor="description ">
                                    Description
                                  </label>
                                  <textarea
                                    type="text"
                                    name="description "
                                    className={`form-control ${
                                      formik.errors.description &&
                                      formik.touched.description
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    rows={3}
                                    id="description "
                                    placeholder="Enter Description"
                                    {...formik.getFieldProps("description")}
                                  />
                                  {formik.errors.description &&
                                    formik.touched.description && (
                                      <span className="invalid-feedback">
                                        {formik.errors.description}
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-footer d-flex justify-content-end">
                            <button type="submit" className="btn btn-primary">
                              Submit
                            </button>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                      <div className="d-flex justify-content-end align-items-center mb-3">
                         
                          <div className="d-flex justify-content-end align-items-end" style={{minWidth:"130px"}}>
                              <button
                                data-toggle="modal"
                                data-target="#modal-default"
                                className="blue-btn"
                                onClick={() => {
                                  setShowForm(true);
                                }}
                              >
                                Add Announcement
                              </button>
                          
                          </div>
                        </div>
                        {/* <Search setTableQaury={setTableQaury} tableQaury={tableQaury} placeHolder={"Search By Name"}/> */}
                        <div className="table-ovwer">
                          <Table
                            columns={columns}
                            data={data}
                            pagination={totalPages}
                            onPageChange={onPageChange}
                            msg={"No data found."}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          {showForm && (
            <Formik
              initialValues={{
                title: "",
                description: "",
              }}
              validationSchema={validationSchemaSe}
              //   enableReinitialize
              onSubmit={async (values, { resetForm }) => {
                try {
                  const response = await handleSubmit(values);
                  if (response?.data?.success) {
                    setShowForm(false)
                    resetForm(); // Reset the form after successful submission
                  }
                } catch (error) {
                  console.error(
                    "Error submitting announcement:",
                    error
                  );
                }
              }}
            >
              {(formik) => (
                <FormModal
                  formik={formik}
                  handleCloseModal={handleCloseModal}
                  title="Announcement"
                >
                  <div className="form-group">
                    <label htmlFor="title">Title</label>
                    <input
                      type="text"
                      name="title"
                      className={`form-control ${
                        formik.errors.title && formik.touched.title
                          ? "is-invalid"
                          : ""
                      }`}
                      id="title"
                      placeholder="Enter Title"
                      {...formik.getFieldProps("title")}
                    />
                    {formik.errors.title && formik.touched.title && (
                      <span className="invalid-feedback">
                        {formik.errors.title}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="description ">Description</label>
                    <textarea
                      type="text"
                      name="description "
                      className={`form-control ${
                        formik.errors.description && formik.touched.description
                          ? "is-invalid"
                          : ""
                      }`}
                      rows={3}
                      id="description "
                      placeholder="Enter Description"
                      {...formik.getFieldProps("description")}
                    />
                    {formik.errors.description &&
                      formik.touched.description && (
                        <span className="invalid-feedback">
                          {formik.errors.description}
                        </span>
                      )}
                  </div>
                </FormModal>
              )}
            </Formik>
          )}
        </>
      )}

      <ConfirmModal
        confirmFn={deleteAuditFn}
        text={"Are you sure,You want to Cancel Audit  ?"}
        buttonText={"Delete"}
      />
    </div>
  );
}

export default AnnouncementsUi;
